/*
  Filter & Sortierung der Suchseite – Die Sellerie

  - Filtert/sortiert automatisch beim Ändern (das Formular wird normal per GET abgeschickt).
  - Leere Preisfelder werden nicht in die URL geschrieben.
  - Mobil (< 990px) ist die Seitenleiste einklappbar; ohne JS bleibt alles sichtbar.
  - Geöffnete Filter-Gruppen bleiben nach dem Neuladen offen (sessionStorage, optional).
*/
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var STORAGE_KEY = 'sellerie-search-filters-open';

  function readOpenGroups() {
    try {
      return JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeOpenGroups(list) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function groupKey(details) {
    var summary = details.querySelector('summary span');
    return summary ? summary.textContent.trim() : '';
  }

  function init(root) {
    var form = root.querySelector('form');
    var toggle = root.querySelector('.sf__toggle');
    var groups = root.querySelectorAll('details.sf__group');
    var mq = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
    var timer = null;
    var i;

    if (!form) {
      return;
    }

    /* Zuvor geöffnete Gruppen wieder öffnen */
    var openGroups = readOpenGroups();
    for (i = 0; i < groups.length; i += 1) {
      if (openGroups.indexOf(groupKey(groups[i])) > -1) {
        groups[i].open = true;
      }
      groups[i].addEventListener('toggle', function (event) {
        var key = groupKey(event.target);
        var list = readOpenGroups();
        var pos = list.indexOf(key);
        if (event.target.open && pos === -1) {
          list.push(key);
        } else if (!event.target.open && pos > -1) {
          list.splice(pos, 1);
        }
        writeOpenGroups(list);
      });
    }

    /* Mobil einklappbar */
    function setMode() {
      var collapsible = !!(mq && mq.matches);
      if (collapsible) {
        root.classList.add('sf--collapsible');
      } else {
        root.classList.remove('sf--collapsible');
        root.classList.remove('sf--open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    toggle.addEventListener('click', function () {
      var open = !root.classList.contains('sf--open');
      if (open) {
        root.classList.add('sf--open');
      } else {
        root.classList.remove('sf--open');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    if (mq) {
      if (mq.addEventListener) {
        mq.addEventListener('change', setMode);
      } else if (mq.addListener) {
        mq.addListener(setMode);
      }
    }
    setMode();

    /* Leere Preisfelder nicht in die URL schreiben */
    function setEmptyFieldsDisabled(disabled) {
      var fields = form.querySelectorAll('input[name^="filter."]');
      var j;
      for (j = 0; j < fields.length; j += 1) {
        if (fields[j].type !== 'checkbox' && fields[j].value === '') {
          fields[j].disabled = disabled;
        }
      }
    }

    form.addEventListener('submit', function () {
      setEmptyFieldsDisabled(true);
    });

    /* Zurück-Button (bfcache): Felder wieder aktivieren */
    window.addEventListener('pageshow', function () {
      setEmptyFieldsDisabled(false);
    });

    /* Automatisch abschicken */
    form.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }, 350);
    });
  }

  function run() {
    var roots = document.querySelectorAll('[data-search-filters]');
    var i;
    for (i = 0; i < roots.length; i += 1) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();